<template>
  <div class="form-list">
    
    <div class="table-search">
      <h3>诊断回复</h3>
      <!-- 列表搜索条件，已封装 -->
      <FormQuery ref="formquery" :data="Query" :key="keyForm" @submit="search" @reset="reset">
      </FormQuery>
      <!-- <div class="tools">
        <el-button type="success" @click="add">发布新托管</el-button>
      </div> -->
    </div>
    <div class="table-content">
      <table-page :data="tableData" :columns="columns" :currentPage="query.pnum" :pageSize="query.psize" :total="total"
        :loading="loading" :border="true" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange"
        @selectionChange="handleSelection">
        <template slot="index" slot-scope="scope">
          <span>{{ scope.index + 1 }}</span>
        </template>
        <template slot="isReply" slot-scope="scope">
          <span>{{ scope.row.isReply == 1 ? "已解答" : "未解答" }}</span>
        </template>
        <!-- <template slot="consultFileVo" slot-scope="scope">
          <span> {{ scope.row. }}</span>
        </template> -->
        <template slot="operation" slot-scope="scope">
          <el-button type="text" size="small" @click="handleReply(scope.row)">解答</el-button>
        </template>
      </table-page>
    </div>

    <Reply v-if="showReply" ref="reply" @closeDialog="closeDialog" />
  </div>
</template>

<script>
  import FormQuery from "@/components/form/form-search";
  import TablePage from "@/components/table/table-page";
  import Reply from "./reply.vue";
  import { getConsultPageAll } from "@/api/technology";

  const Query = [

    {
      name: "keyword",
      label: "关键字：",
      componentType: "input",
      placeholder: "请选择",
      width: "140px",
      inputType: "",

    },

    // {
    //   name: "companyName",
    //   label: "接管人：",
    //   componentType: "input",
    //   placeholder: "请选择",
    //   width: "180px",
    //   dataOptions: [],
    // },
  ];

  const columns = [
    {
      prop: "index",
      label: "序号",
      width: 80,
      template: true,
    },
    {
      prop: "consultTitle",
      label: "作物类型",
      width: 120,
    },
    {
      prop: "consultDesc",
      label: "问题描述",
    },
    // {
    //   prop: "consultFileVo",
    //   label: "附件",
    //   width: 200,
    //   template: true,
    // },
    {
      prop: "isReply",
      label: "状态",
      width: 100,
      template: true,
    },
    {
      prop: "createTime",
      label: "创建时间",
      width: 200,
    },
    {
      prop: "operation",
      label: "操作",
      width: 120,
      template: true,
    },
  ];

  export default {
    components: { FormQuery, TablePage, Reply },
    data() {
      return {
        // 弹窗
        showReply: false,
        // 分页
        query: {
          pnum: 1,
          psize: 10,
        },
        keyForm: 1,
        // 列表数据
        tableData: [],
        // 总条数
        total: 0,
        // 加载状态
        loading: false,
        // 列
        columns,
        Query: Query,
        showEdit: false,
      };
    },
    methods: {
      // 打开弹窗
      handleReply(row) {
        this.showReply = true;
        this.$nextTick(() => {
          this.$refs.reply.editObj(row, false);
        });

      },
      // 关闭弹框
      closeDialog() {
        this.showReply = false
        this.getList()
      },
      dialogClose(val) {
        // 关闭弹窗
        this.dialogVisible = val;
      },

      // 搜索
      search(params) {

        this.params = {
          keyword: params.keyword,
        }
        this.query.pnum = 1;
        // 组装条件
        this.query = {
          ...this.query,
          ...params,
        };
        console.log("search", params)
        this.getList();
      },
      reset() {

      },
      // 获取列表
      async getList() {
        this.loading = true;
        let res = await getConsultPageAll(this.query);
        if (!res.code) {
          this.tableData = res.data.records;
          this.total = +res.data.total;
          this.loading = false;
        } else {
          this.$message.error("查询失败");
          this.loading = false;
        }
      },
      //分页单页切换
      handleCurrentChange(page) {
        this.query.pnum = page;
        this.getList();
      },
      //分页总页数切换
      handleSizeChange(size) {
        this.query = {
          pnum: 1,
          psize: size,
        };
        this.getList();
      },
      handleSelection(selects) {
        console.log(selects);
      },
    },
    created() {
      this.getList();
    },
  };
</script>

<style lang="less" scoped>
  .form-list {
    .table-search {
      padding: 0 0 0 30px;

      /deep/.el-button {
        padding: 10px 20px !important;
      }

      .tools {
        margin-bottom: 18px;
        margin-top: 6px;
      }
    }

    .table-content {
      padding: 0 30px;
    }
  }
</style>
